<template>
  <select
    v-bind="$attrs"
    class="form-control"
    :value="$attrs.modelValue"
    data-test="market-select"
    @input="$emit('update:modelValue', $event.target.value)"
  >
    <option value="" disabled>
      {{ $t('Select market') }}
    </option>
    <option v-for="(market, marketKey) in markets" :key="marketKey" :value="marketKey">
      {{ $t(market.name) }} &mdash; {{ market.currency }}
    </option>
  </select>
</template>

<script>
export default {
  computed: {
    markets() {
      return currentMarkets
    },
  },
}
</script>
